var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useState } from "react";
import { SaveButton, SimpleForm, useNotify, Toolbar, DateTimeInput, useGetList, } from "react-admin";
import { AccordionDetails, AccordionSummary, MenuItem, FormControlLabel, Switch, Typography, } from "@mui/material";
import { useMutation } from "@apollo/client";
import MailIcon from "@mui/icons-material/Mail";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { PageHeaderStyles } from "@/components/styles/PageHeaderStyles";
import EmailEditor from "@/components/EmailEditor";
import { useTranslation } from "react-i18next";
import { FormStyles } from "@/components/styles/FormStyles";
import { ElectionHeaderStyles } from "@/components/styles/ElectionHeaderStyles";
import { CREATE_SCHEDULED_EVENT } from "@/queries/CreateScheduledEvent";
import { getReferencedSecretAttributeNames } from "@/services/secretAttributeTemplates";
import { ScheduledEventType } from "@/services/ScheduledEvent";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { ITemplateMethod } from "@/types/templates";
import { useLocation } from "react-router-dom";
export var AudienceSelection;
(function (AudienceSelection) {
    AudienceSelection["ALL_USERS"] = "ALL_USERS";
    AudienceSelection["NOT_VOTED"] = "NOT_VOTED";
    AudienceSelection["VOTED"] = "VOTED";
    AudienceSelection["SELECTED"] = "SELECTED";
})(AudienceSelection || (AudienceSelection = {}));
export var SendTemplate = function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var ids = _a.ids, audienceSelection = _a.audienceSelection, close = _a.close, electionEventId = _a.electionEventId, _h = _a.secretAttributeNames, secretAttributeNames = _h === void 0 ? [] : _h;
    var globalSettings = useContext(SettingsContext).globalSettings;
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var location = useLocation();
    var notify = useNotify();
    var _j = useState(null), errors = _j[0], setErrors = _j[1];
    var createScheduledEvent = useMutation(CREATE_SCHEDULED_EVENT)[0];
    var _k = useState(false), showProgress = _k[0], setShowProgress = _k[1];
    var _l = useState({
        audience: {
            selection: audienceSelection !== null && audienceSelection !== void 0 ? audienceSelection : AudienceSelection.SELECTED,
            voter_ids: ids !== null && ids !== void 0 ? ids : undefined,
        },
        communication_method: ITemplateMethod.EMAIL,
        schedule: {
            now: true,
            date: undefined,
        },
        i18n: {
            en: {
                email: {
                    subject: (_b = globalSettings.DEFAULT_EMAIL_SUBJECT["en"]) !== null && _b !== void 0 ? _b : "",
                    plaintext_body: (_c = globalSettings.DEFAULT_EMAIL_PLAINTEXT_BODY["en"]) !== null && _c !== void 0 ? _c : "",
                    html_body: (_d = globalSettings.DEFAULT_EMAIL_HTML_BODY["en"]) !== null && _d !== void 0 ? _d : "",
                },
                sms: {
                    message: (_e = globalSettings.DEFAULT_SMS_MESSAGE["en"]) !== null && _e !== void 0 ? _e : "",
                },
            },
        },
        language_conf: {
            enabled_languages: ["en"],
            default_language_code: "en",
        },
    }), template = _l[0], setTemplate = _l[1];
    var getPayload = function (formData) {
        var templateContents = JSON.stringify(formData.i18n);
        return {
            audience_selection: formData.audience.selection,
            audience_voter_ids: formData.audience.voter_ids,
            communication_method: formData.communication_method,
            schedule_now: formData.schedule.now,
            schedule_date: formData.schedule.date,
            email: formData.i18n["en"].email,
            sms: formData.i18n["en"].sms,
            secret_attribute_names: getReferencedSecretAttributeNames(templateContents, secretAttributeNames),
        };
    };
    var onSubmit = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
        var errors_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setErrors(null);
                    setShowProgress(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, createScheduledEvent({
                            variables: {
                                tenantId: tenantId,
                                electionEventId: electionEventId,
                                eventProcessor: ScheduledEventType.SEND_TEMPLATE,
                                cronConfig: undefined,
                                eventPayload: getPayload(formData),
                            },
                        })];
                case 2:
                    errors_1 = (_a.sent()).errors;
                    setShowProgress(false);
                    if (errors_1) {
                        setErrors(t("sendCommunication.errorSending", { error: errors_1.toString() }));
                        return [2 /*return*/];
                    }
                    else {
                        notify(t("sendCommunication.successSending"), { type: "success" });
                        close === null || close === void 0 ? void 0 : close();
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setShowProgress(false);
                    setErrors(t("sendCommunication.errorSending", { error: error_1.toString() }));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleNowChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var checked, newTemplate;
        return __generator(this, function (_a) {
            checked = e.target.checked;
            newTemplate = __assign({}, template);
            newTemplate.schedule.now = checked;
            setTemplate(newTemplate);
            return [2 /*return*/];
        });
    }); };
    var handleSmsChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value, newTemplate;
        return __generator(this, function (_a) {
            value = e.target.value;
            newTemplate = __assign({}, template);
            newTemplate.i18n["en"].sms = { message: value };
            setTemplate(newTemplate);
            return [2 /*return*/];
        });
    }); };
    var handleSelectChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value, newTemplate;
        return __generator(this, function (_a) {
            value = e.target.value;
            newTemplate = __assign({}, template);
            newTemplate.audience.selection = value;
            setTemplate(newTemplate);
            return [2 /*return*/];
        });
    }); };
    var handleSelectMethodChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value, newTemplate, selectedReceipts;
        return __generator(this, function (_a) {
            value = e.target.value;
            newTemplate = __assign({}, template);
            newTemplate.communication_method = value;
            setTemplate(newTemplate);
            setSelectedMethod(value);
            selectedReceipts = receipts === null || receipts === void 0 ? void 0 : receipts.filter(function (receipt) { return receipt.communication_method === value; }).map(function (receipt) { return receipt.template; });
            setSelectedList(selectedReceipts !== null && selectedReceipts !== void 0 ? selectedReceipts : null);
            return [2 /*return*/];
        });
    }); };
    var handleSelectAliasChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value, newTemplate, selectedReceipt, newEmail, newSms, newSMSCommunication, a;
        var _a, _b;
        return __generator(this, function (_c) {
            console.log("handleSelectAliasChange", e.target.value);
            value = e.target.value;
            newTemplate = __assign({}, template);
            newTemplate.alias = value;
            console.log("handleSelectAliasChange newTemplate", newTemplate);
            setTemplate(newTemplate);
            selectedReceipt = receipts === null || receipts === void 0 ? void 0 : receipts.filter(function (receipt) {
                return receipt.communication_method === selectedMethod && receipt.template.alias === value;
            });
            if (selectedReceipt && selectedReceipt.length > 0) {
                console.log("selectedReceipt", selectedReceipt[0]["template"][selectedMethod.toLowerCase()]);
                if (selectedMethod === ITemplateMethod.EMAIL) {
                    newEmail = selectedReceipt[0]["template"][selectedMethod.toLowerCase()];
                    setEmail(newEmail, value);
                }
                else {
                    newSms = selectedReceipt[0]["template"][selectedMethod.toLowerCase()]
                        .message;
                    newSMSCommunication = __assign({}, newTemplate);
                    a = (_a = newSMSCommunication.i18n) === null || _a === void 0 ? void 0 : _a["en"];
                    if ((_b = a === null || a === void 0 ? void 0 : a.sms) === null || _b === void 0 ? void 0 : _b.message) {
                        a.sms.message = newSms;
                    }
                    setTemplate(newSMSCommunication);
                }
            }
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        console.log("handleSelectAliasChange communication", template);
    }, [template]);
    var setEmail = function (newEmail_1) {
        var args_1 = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args_1[_i - 1] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([newEmail_1], args_1, true), void 0, function (newEmail, alias) {
            var newTemplate;
            if (alias === void 0) { alias = ""; }
            return __generator(this, function (_a) {
                newTemplate = __assign(__assign({}, template), { alias: alias });
                newTemplate.i18n["en"].email = newEmail;
                setTemplate(newTemplate);
                return [2 /*return*/];
            });
        });
    };
    var handleLangChange = function (lang) { return function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var checked, newTemplate;
        return __generator(this, function (_a) {
            checked = e.target.checked;
            newTemplate = __assign({}, template);
            if (checked) {
                // Add the language if it's not already in the array
                if (!newTemplate.language_conf.enabled_languages.includes(lang)) {
                    newTemplate.language_conf.enabled_languages.push(lang);
                }
            }
            else {
                // Remove the language if it's in the array
                newTemplate.language_conf.enabled_languages =
                    newTemplate.language_conf.enabled_languages.filter(function (l) { return l !== lang; });
            }
            setTemplate(newTemplate);
            return [2 /*return*/];
        });
    }); }; };
    var validateDate = function (value) {
        if (!template.schedule.now && !value) {
            return t("sendCommunication.chooseDate");
        }
    };
    // communication templates
    var _m = useState(ITemplateMethod.EMAIL), selectedMethod = _m[0], setSelectedMethod = _m[1];
    var _o = useState(null), selectedList = _o[0], setSelectedList = _o[1];
    /*const [selectedReceipt, setSelectedReceipt] = useState<IEmail | string>({
        subject: "",
        plaintext_body: "",
        html_body: "",
    })*/
    var receipts = useGetList("sequent_backend_template", {
        filter: {
            tenant_id: tenantId,
        },
    }).data;
    useEffect(function () {
        // filter receipts by communication method
        var selectedReceipts = receipts === null || receipts === void 0 ? void 0 : receipts.filter(function (receipt) { return receipt.communication_method === selectedMethod; }).map(function (receipt) { return receipt.template; });
        setSelectedList(selectedReceipts !== null && selectedReceipts !== void 0 ? selectedReceipts : null);
    }, [selectedMethod, receipts]);
    return (_jsx(PageHeaderStyles.Wrapper, { children: _jsxs(SimpleForm, { toolbar: _jsx(Toolbar, { children: _jsx(SaveButton, { icon: _jsx(MailIcon, {}), label: String(t("sendCommunication.sendButton")), alwaysEnable: true }) }), record: template, onSubmit: onSubmit, sanitizeEmptyValues: true, children: [_jsx(PageHeaderStyles.Title, { children: t("sendCommunication.title") }), _jsx(PageHeaderStyles.SubTitle, { children: t("sendCommunication.subtitle") }), _jsxs(FormStyles.AccordionExpanded, { expanded: true, disableGutters: true, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "send-communication-voters" }), children: _jsx(ElectionHeaderStyles.Wrapper, { children: _jsx(ElectionHeaderStyles.Title, { children: t("sendCommunication.voters") }) }) }), _jsx(AccordionDetails, { children: _jsx(FormStyles.Select, { name: "audience.selection", value: template.audience.selection, onChange: handleSelectChange, children: Object.keys(AudienceSelection).map(function (key) {
                                    var _a, _b;
                                    return (_jsx(MenuItem, { value: key, children: t("sendCommunication.votersSelection.".concat(key), {
                                            total: (_b = (_a = template.audience.voter_ids) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0,
                                            voters: location.pathname.includes("user")
                                                ? t("sendCommunication.path.users")
                                                : t("sendCommunication.path.voters"),
                                        }) }, key));
                                }) }) })] }), _jsxs(FormStyles.AccordionExpanded, { expanded: true, disableGutters: true, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "send-communication-schedule" }), children: _jsx(ElectionHeaderStyles.Wrapper, { children: _jsx(ElectionHeaderStyles.Title, { children: t("sendCommunication.schedule") }) }) }), _jsxs(AccordionDetails, { children: [_jsx(FormControlLabel, { label: String(t("sendCommunication.nowInput")), control: _jsx(Switch, { checked: template.schedule.now, onChange: handleNowChange }) }, "nowInput"), _jsx(DateTimeInput, { validate: validateDate, disabled: template.schedule.now, source: "schedule.date", label: String(t("sendCommunication.dateInput")), parse: function (value) { return new Date(value).toISOString(); } })] })] }), _jsxs(FormStyles.AccordionExpanded, { expanded: true, disableGutters: true, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreIcon, { id: "send-communication-method" }), children: _jsx(ElectionHeaderStyles.Wrapper, { children: _jsx(ElectionHeaderStyles.Title, { children: t("sendCommunication.methodTitle") }) }) }), _jsxs(AccordionDetails, { children: [_jsx(Typography, { variant: "body2", sx: { margin: "0" }, children: t("sendCommunication.method") }), " ", _jsx(FormStyles.Select, { name: "voters.selection", value: template.communication_method, onChange: handleSelectMethodChange, children: Object.values(ITemplateMethod)
                                        .filter(function (method) { return method !== ITemplateMethod.DOCUMENT; })
                                        .map(function (key) { return (_jsx(MenuItem, { value: key, children: t("sendCommunication.communicationMethod.".concat(key)) }, key)); }) }), _jsx(Typography, { variant: "body2", sx: { margin: "0" }, children: t("sendCommunication.alias") }), _jsx(FormStyles.Select, { name: "alias", value: template.alias || "", onChange: handleSelectAliasChange, children: selectedList
                                        ? selectedList === null || selectedList === void 0 ? void 0 : selectedList.map(function (key, index) { return (_jsx(MenuItem, { value: key.alias, children: key.alias }, index)); })
                                        : null }), template.communication_method === ITemplateMethod.EMAIL &&
                                    template.i18n["en"].email && (_jsx(EmailEditor, { record: template.i18n["en"].email, setRecord: setEmail })), template.communication_method === ITemplateMethod.SMS && (_jsx(FormStyles.TextField, { name: "sms", label: String(t("sendCommunication.smsMessage")), value: (_g = (_f = template.i18n["en"].sms) === null || _f === void 0 ? void 0 : _f.message) !== null && _g !== void 0 ? _g : "", onChange: handleSmsChange, multiline: true, minRows: 4 }))] })] }), _jsxs(FormStyles.StatusBox, { children: [showProgress ? _jsx(FormStyles.ShowProgress, {}) : null, errors ? (_jsx(FormStyles.ErrorMessage, { variant: "body2", children: errors })) : null] })] }) }));
};
